import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const ListingCardPlaceholder = (props: IContentLoaderProps) => {
  return (
    <div className="listing-card-placeholder">
      <ContentLoader
        {...props}
        style={{ padding: '24px' }}
        backgroundColor="#e7f1fc"
        foregroundColor="#ffffff"
        viewBox="0 0 673 195"
      >
        <rect x="513" y="0" rx="24" ry="24" width="160" height="120" />
        <rect x="0" y="0" rx="8" ry="8" width="250" height="24" />
        <rect x="0" y="32" rx="8" ry="8" width="300" height="24" />
        <rect x="0" y="64" rx="8" ry="8" width="100" height="17" />
        <rect x="124" y="64" rx="8" ry="8" width="100" height="17" />
        <rect x="0" y="103" rx="8" ry="8" width="6" height="6" />
        <rect x="14" y="97" rx="8" ry="8" width="160" height="18" />
        <rect x="0" y="125" rx="8" ry="8" width="6" height="6" />
        <rect x="14" y="119" rx="8" ry="8" width="123" height="18" />
        <rect x="0" y="153" rx="8" ry="8" width="104" height="42" />
        <rect x="124" y="153" rx="8" ry="8" width="104" height="42" />
        <rect x="248" y="153" rx="8" ry="8" width="104" height="42" />
      </ContentLoader>
    </div>
  );
};

export const ListingCardPlaceholderResponsive = (
  props: IContentLoaderProps,
) => {
  return (
    <div className="listing-card-placeholder responsive">
      <ContentLoader
        {...props}
        style={{ padding: '24px' }}
        backgroundColor="#e7f1fc"
        foregroundColor="#ffffff"
        viewBox="0 0 464 170"
      >
        <rect x="304" y="0" rx="24" ry="24" width="160" height="120" />
        <rect x="0" y="0" rx="8" ry="8" width="140" height="20" />
        <rect x="0" y="28" rx="8" ry="8" width="210" height="18" />
        <rect x="0" y="54" rx="8" ry="8" width="100" height="16" />
        <rect x="124" y="54" rx="8" ry="8" width="100" height="16" />
        <rect x="0" y="92" rx="8" ry="8" width="6" height="6" />
        <rect x="14" y="86" rx="8" ry="8" width="124" height="18" />
        <rect x="0" y="114" rx="8" ry="8" width="6" height="6" />
        <rect x="14" y="108" rx="8" ry="8" width="124" height="18" />
        <rect x="0" y="142" rx="8" ry="8" width="104" height="22" />
        <rect x="124" y="142" rx="8" ry="8" width="104" height="22" />
        <rect x="248" y="142" rx="8" ry="8" width="104" height="22" />
      </ContentLoader>
    </div>
  );
};
